import { CatalogContentType } from '../../catalog/CatalogContentType';
import { ExplorableItemType } from '../../spacesPlatform/models/ContentType';
import { ExploreContentApi_ContentType } from '../../ts/ServerApi/types/IContent';

export const SITE_SPACE_EXPLORE = 'explore';
export type SiteSpaceContentType = ExploreContentApi_ContentType | CatalogContentType | 'explore';

export function convertSiteContentTypeToContentType(siteContentType: SiteSpaceContentType): ExplorableItemType {
  switch (siteContentType) {
    case SITE_SPACE_EXPLORE:
      return 'project';
    default:
      return siteContentType;
  }
}
